import React from 'react';
import PropTypes from 'prop-types';
import { BoldTitle, SubTitle } from '../../../CustomizedComponents/Texts';
import SectionWrapper from '../../../CardRow/SectionWrapper';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import CustomTextField from '../../../CustomizedComponents/CustomTextField';

const TextFieldWrapper = styled.div`
    width: '100%';
    display: 'flex';
`;

const getPanel = ( value, editable, title, handler, range, type ) => {
  return (
    <CustomTextField
      style={{ width: '27%' }}
      onChange={
        (event) => {
          const target = event.target;
          handler((oldState) => {
            return { ...oldState, [type]: { ...oldState[type], [range]: target.value } };
          });
        }
      }
      value={value}
      type='time'
      label={<FormattedMessage id={title} />}
      disabled={!editable}
      variant="outlined"
    />
  );
};

const TradingTime = (
  {
    data,
    handler,
    editable,
  } ) => {
  const timeTitle = 'app.configuration.time.deal';
  const fromTitle = 'app.time.from';
  const toTitle = 'app.time.to';
  const settlement = 'app.settlement';
  const bestAskTitle = 'app.configuration.bestAsk';
  const tomorrowFromTitle = 'app.time.tomorrow.from';
  const tomorrowToTitle = 'app.time.tomorrow.to';

  return (
    <>
      <SectionWrapper>
        <BoldTitle title={timeTitle} />
      </SectionWrapper>
      <SectionWrapper>
        <SubTitle title={bestAskTitle} />
        <TextFieldWrapper>
          {getPanel(data?.currentDayPeriodBestAsk?.from, editable, fromTitle, handler, 'from', 'currentDayPeriodBestAsk')}
          {getPanel(data?.currentDayPeriodBestAsk?.to, editable, toTitle, handler, 'to', 'currentDayPeriodBestAsk')}
        </TextFieldWrapper>
      </SectionWrapper>
      <SectionWrapper>
        <SubTitle title={settlement} />
        <TextFieldWrapper>
          {getPanel(data?.currentDayPeriodSettlement?.from, editable, fromTitle, handler, 'from', 'currentDayPeriodSettlement')}
          {getPanel(data?.currentDayPeriodSettlement?.to, editable, toTitle, handler, 'to', 'currentDayPeriodSettlement')}
        </TextFieldWrapper>
        <TextFieldWrapper>
          {getPanel(data?.nextDayPeriodSettlement?.from, editable, tomorrowFromTitle, handler, 'from', 'nextDayPeriodSettlement')}
          {getPanel(data?.nextDayPeriodSettlement?.to, editable, tomorrowToTitle, handler, 'to', 'nextDayPeriodSettlement')}
        </TextFieldWrapper>
      </SectionWrapper>
    </>
  );
};

TradingTime.propTypes = {
  data: PropTypes.object,
  editable: PropTypes.bool,
  handler: PropTypes.func,
};

export default TradingTime;
